import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";

const RefundPloicy = () => {
  return (
    <>
      <Meta title={"Refund Policy - Shoplintic Fashion & Beauty"} />
      <BreadCrumb title="Refund Policy - Fashion & Beauty" />
        <div className="bg-gray-50 min-h-screen py-12">
      <div className="p-4 max-w-5xl mx-auto bg-white p-10 rounded-2xl shadow-lg">
        <h4 className="text-4xl font-bold text-blue-700 mb-8 text-center">Refund & Return Policy</h4>

        <p className="text-gray-700 mb-6">
          Thank you for shopping at <strong>Shoplintic</strong>. We aim to provide high-quality fashion and beauty products that meet your needs and expectations. However, if you are not entirely satisfied with your purchase, we're here to help. Please review our refund and return policy below for all purchases made through our online store at <a href="https://shoplintic.in" className="text-blue-600 underline">shoplintic.in</a>.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">1. Return Eligibility</h4>
        <p className="text-gray-700 mb-4">
          You may request a return within <strong>7 days</strong> of receiving your order for clothing items and <strong>30 days</strong> for unopened cosmetics. To be eligible for a return:
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-1">
          <li><strong>Clothing:</strong> Items must be unused, unworn, with original tags attached, and in the same condition received.</li>
          <li><strong>Cosmetics:</strong> Products must be unopened, sealed, and in original packaging.</li>
          <li>All items must be in original packaging with all accessories and documentation.</li>
          <li>You must provide proof of purchase (receipt or order number).</li>
        </ul>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">2. Non-Returnable Items</h4>
        <p className="text-gray-700 mb-6">
          Certain items are not eligible for return or refund:
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-1">
          <li>Opened cosmetics, makeup, skincare, or fragrance products</li>
          <li>Worn or used clothing items</li>
          <li>Items without original tags or packaging</li>
          <li>Customized or personalized products</li>
          <li>Items damaged due to customer misuse, negligence, or improper care</li>
          <li>Perishable or time-sensitive beauty products past their expiration date</li>
        </ul>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">3. Refund Process</h4>
        <p className="text-gray-700 mb-6">
          Once your return is received and inspected, we will notify you via email about the approval or rejection of your refund. If approved, your refund will be processed within 5–10 business days using your original method of payment.
        </p>
        <p className="text-gray-700 mb-6">
          In case of delays due to payment gateways or banks, we appreciate your patience and cooperation. If you haven’t received a refund after 10 working days, please contact your bank first. If the issue remains unresolved, email us at <a href="mailto:support@shoplintic.in" className="text-blue-600 underline">support@shoplintic.in</a>.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">4. Exchanges & Size Swaps</h4>
        <p className="text-gray-700 mb-6">
          <strong>Clothing Exchanges:</strong> We offer free size exchanges within 7 days of delivery. If the item doesn't fit or you prefer a different size/color, contact our support team. We will provide a prepaid return label and send the replacement once we receive your return.<br /><br />
          <strong>Cosmetics Exchanges:</strong> We replace items only if they are defective or damaged. For unopened products, exchanges are available within 30 days.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">5. Return Shipping</h4>
        <p className="text-gray-700 mb-6">
          <strong>Clothing Returns:</strong> We provide prepaid return labels for size exchanges. For other returns, customers are responsible for return shipping costs.<br /><br />
          <strong>Cosmetics Returns:</strong> Return shipping costs are borne by the customer unless the item is damaged or incorrect. We recommend using a trackable shipping service for valuable beauty products.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">6. Damaged, Defective, or Wrong Items</h4>
        <p className="text-gray-700 mb-6">
          If you received a damaged, defective, or incorrect product, notify us within 48 hours of delivery. Send a detailed description and photographic evidence to <a href="mailto:support@shoplintic.in" className="text-blue-600 underline">support@shoplintic.in</a>. We will review the issue and either replace or refund the item. For cosmetics, we may require batch number verification for quality control.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">7. Product Quality & Safety</h4>
        <p className="text-gray-700 mb-6">
          All our products undergo quality checks before shipping. For cosmetics, we ensure products meet safety standards and include proper labeling. If you experience any adverse reactions, discontinue use immediately and consult a healthcare professional. We are not liable for allergic reactions or sensitivities to ingredients listed on packaging.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">8. Cancellations</h4>
        <p className="text-gray-700 mb-6">
          Orders can be canceled within 12 hours of placing them or before they are shipped—whichever is earlier. Once the order has been dispatched, it cannot be canceled and will fall under the return/refund process. For custom or personalized items, cancellations may not be possible once production has begun.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">9. Contact Us</h4>
        <p className="text-gray-700 mb-6">
          If you have any questions or concerns about our refund policy, feel free to reach out to us. We are committed to resolving your concerns professionally and promptly.
        </p>
        <p className="text-gray-700 mb-6">
          📧 Email: <a href="mailto:support@shoplintic.in" className="text-blue-600 underline">support@shoplintic.in</a><br />
          🌐 Website: <a href="https://shoplintic.in" className="text-blue-600 underline">shoplintic.in</a>
        </p>

        <p className="text-sm text-gray-500 mt-10">Last Updated: June 5, 2025</p>
      </div>
    </div>
    </>
  );
};

export default RefundPloicy;
